var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('b-row',[_c('b-col',{attrs:{"xl":"2","sm":"3"}},[_c('keep-alive',[_c('Menu',{on:{"back":_vm.handleBack}})],1)],1),_c('b-col',{attrs:{"xl":"10","sm":"9"}},[_c('Viewer',{on:{"back":function($event){return _vm.handleBack()}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }